import { faArrowRightArrowLeft } from "@jewlr/pro-light-svg-icons/faArrowRightArrowLeft"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { push } from "redux-first-history"

import { history } from "app-store-v2/index"
import { fetchShareEmail } from "app-store-v2/share/actions"
import AcceptPayments from "areas/cart/footer/accept-payments"
import ItemEditForm from "components/admin/item-edit-form"
import { openModal } from "components/modal"
import { PdpThresholdProgressBar } from "components/threshold-progress-bar"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import {
  IS_JEWLR,
  IS_PORTAL,
  isTestMode,
  IS_GE_CHECKOUT,
} from "helpers/application"

import AddToCartButton from "./add-to-cart-button"
import OutOfStockForm from "./out-of-stock-form"
import PDPValueProps from "./pdp-value-props"
import ShippingInfo from "./shipping-info"
import SocialShare from "./social-share"

const ReturnPolicyLink = () => {
  const is_ge_checkout = IS_GE_CHECKOUT()

  return (
    <div className="tablet:text-left text-center">
      <Button
        className="mb-16"
        onClick={() => {
          if (!isTestMode) {
            dataLayer.push({
              event: "clicked-pdp-return-policy",
            })
          }
          openModal("#return-policy")
        }}
        text
        underline
      >
        <FontAwesomeIcon
          className="text-15 mr-8"
          icon={faArrowRightArrowLeft}
        />
        <p className="text-15 tablet:font-medium">
          {is_ge_checkout ? "30" : "99"}-Day Return Policy
        </p>
      </Button>
    </div>
  )
}

const InternalWizardActions = ({
  adminMode,
  formUrl,
  hasDiamondSelector,
  header,
  imageAreaRef,
  olid,
  openShareModal,
  orderNumber,
  outOfStockRef,
  pdpValuePropsExp,
  prefStore,
  previewImage,
  // unifiedStonePickerExp,
  wizardLoading,
  wizardRef,
}) => {
  if (!header) return null

  // if (!prefStore) {
  //   return (
  //     <>
  //       <Shimmer
  //         className="tablet:hidden mb-8 w-full"
  //         style={{ height: "48px" }}
  //       />
  //       <Shimmer className="mb-20 w-full" style={{ height: "48px" }} />
  //       {IS_PORTAL() && <AcceptPayments />}
  //       {IS_JEWLR() && <ReturnPolicyLink />}
  //       <ShippingInfo />
  //       {IS_JEWLR() && (
  //         <Shimmer
  //           className="desktop:mb-70 w-full"
  //           style={{ height: "48px" }}
  //         />
  //       )}
  //     </>
  //   )
  // }

  if (header.product_out_of_stock) {
    return (
      <>
        <OutOfStockForm outOfStockRef={outOfStockRef} />
        <ShippingInfo />
      </>
    )
  } else if (olid) {
    return (
      <>
        <ItemEditForm />
        {adminMode ? (
          <Button
            className="text-neutral border-neutral text-18 w-full border disabled:border-none"
            disabled={!prefStore || wizardLoading}
            onClick={() => (window.location = `${formUrl}?cancel=true`)}
            rel="nofollow"
            variant="tertiary"
          >
            Cancel Change
          </Button>
        ) : (
          <Button
            asChild
            className="text-neutral border-neutral text-18 w-full border disabled:border-none"
            disabled={!prefStore || wizardLoading}
            variant="tertiary"
          >
            <Link
              data-lc="wizard-actions"
              rel="nofollow"
              to={`/order/change?order_number=${orderNumber}&lii=${olid}`}
            >
              Cancel Change
            </Link>
          </Button>
        )}
      </>
    )
  }

  return (
    <>
      <AddToCartButton
        imageAreaRef={imageAreaRef}
        previewImage={previewImage}
        wizardRef={wizardRef}
      />
      {IS_PORTAL() && <AcceptPayments />}
      {sl.config.sale_key.includes("2025_jewlr_days_flash") && (
        <div className="mb-16">
          <PdpThresholdProgressBar inPdp />
        </div>
      )}
      {IS_JEWLR() &&
        (pdpValuePropsExp == 1 && !hasDiamondSelector ? (
          <PDPValueProps />
        ) : (
          <ReturnPolicyLink />
        ))}
      <ShippingInfo />
      {IS_JEWLR() && (
        <div className="desktop:flex-col flex">
          <div className="flex-1">
            <Button
              className="tablet:border tablet:border-neutral text-primary tablet:text-black tablet:text-18 tablet:font-light tablet:no-underline mx-auto w-full disabled:border-none"
              data-cy="product-wizard-send-a-hint-btn"
              disabled={!prefStore || wizardLoading}
              onClick={() => openShareModal("product")}
              underline
              variant="tertiary"
            >
              Send a Hint
            </Button>
          </div>
          <SocialShare />
        </div>
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  const allViews = state.previewImage.data?.all_views || []
  const slides = state.previewImage.data?.images || []
  const previewSlide = Object.entries(slides).find(([view]) =>
    allViews.includes(view.replace("_view", ""))
  )

  return {
    adminMode: state.wizard.adminMode,
    formUrl: state.wizard.formUrl,
    hasDiamondSelector: state.wizard.hasDiamondSelector,
    header: state.wizard.header,
    olid: state.wizard.olid,
    orderNumber: state.wizard.orderNumber,
    pdpValuePropsExp: state.experiment.pdpValueProps.variant_id,
    prefStore: state.wizardUI.prefStore,
    previewImage: previewSlide ? previewSlide[1] : null,
    // unifiedStonePickerExp: state.experiment.unifiedStonePicker.variant_id,
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    openShareModal: () => {
      dispatch(fetchShareEmail())
      dispatch(
        push(
          `${history.location.pathname}${history.location.search}#share-modal`
        )
      )
    },
  }
}

InternalWizardActions.propTypes = {
  adminMode: PropTypes.bool,
  formUrl: PropTypes.string,
  hasDiamondSelector: PropTypes.bool,
  header: PropTypes.object,
  imageAreaRef: PropTypes.object,
  olid: PropTypes.any,
  openShareModal: PropTypes.func,
  orderNumber: PropTypes.string,
  outOfStockRef: PropTypes.object,
  pdpValuePropsExp: PropTypes.number,
  prefStore: PropTypes.bool,
  previewImage: PropTypes.object,
  // unifiedStonePickerExp: PropTypes.number,
  wizardLoading: PropTypes.string,
  wizardRef: PropTypes.object,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalWizardActions)
